<div [ngClass]="['statistics-card-container', !isCount() ? 'row-2' : 'row-3']">
  <h4 class="statistics-card-title" iuLoading [dataToWatch]="stats()?.label">
    {{ stats()?.label }}
  </h4>

  @if (!isCount() && stats()?.amount >= 0) {
    <span
      class="statistics-card-total"
      iuNumberAnimation
      [data]="stats()?.amount"
      [formatter]="formatter()"
      [playAnimation]="animateData"></span>
  }

  <div class="statistics-card-percentage">
    <div class="percentage" iuLoading [dataToWatch]="stats" (onTimeout)="setAnimateDataState($event)">
      <span class="percentage-operator">{{ stats()?.indicator }}</span>
      <span
        class="percentage-value"
        iuNumberAnimation
        [data]="stats()?.pct"
        [playAnimation]="true"
        (numberEmitter)="bindAnimatedValue($event, 'pct')"></span>
      <span class="percentage-unit">%</span>
    </div>
    <i
      aria-hidden="true"
      [ngClass]="{
        indicator: true,
        'percentage-fill': true,
        'icon-arrow-up': stats()?.indicator === '+',
        'icon-arrow-down': stats()?.indicator === '-',
      }"
      style="--value: {{ animatedData?.pct }};"></i>
  </div>

  @if (isCount()) {
    <div class="statistics-card-additional">
      <div class="additional">
        <h5 class="additional-label">{{ 'statisticsCard.countLabel' | translate }}</h5>
        <span class="additional-value" iuNumberAnimation [data]="stats()?.count" [playAnimation]="animateData"></span>
      </div>
      <div class="additional">
        <h5 class="additional-label">{{ 'statisticsCard.conversionRate' | translate }}</h5>
        <div class="additional-value-wrapper">
          <span class="additional-value" iuNumberAnimation [data]="stats()?.amount" [playAnimation]="animateData">
          </span>
          <span class="additional-value"> % </span>
        </div>
      </div>
    </div>
  }
</div>
